(function(global) {
    'use strict';
    
    var mms = global.mms || (global.mms = {});

    function State() {
        this.painting = 0;
        this.tweening = '';
        this.rotated = false;
        this.uv = false;
        this.zoom = false;
        this.zoomRect = {1: null, 2: null, 3: null};
        this.zoomPos = {1: null, 2: null, 3: null};
        this.info = false;
        this.backEnabled = false;
        this.buttonsEnabled = false;
        this.highlight = 0;
        this.signals = new StateSignals();
    }
    State.TWEEN_SCREEN = 'screen';
    State.TWEEN_PAINTING = 'painting';
    State.TWEEN_ZOOM = 'zoom';
    State.TWEEN_INFO = 'info';
    State.HIGHLIGHT_TIMEOUT = 3000;
    State.prototype = {
        setPainting: function(value) {
            if (this.painting != value && !this.tweening) {
                if (this.rotated) {
                    this.setRotated(false);
                }
                var prevValue = this.painting;
                this.painting = value;
                if (this.painting) {
                    this.stopHighlight();
                    this.setHighlight(this.painting);
                }
                else {
                    this.zoomPos[prevValue] = {x: this.zoomRect[prevValue].width/2, y: this.zoomRect[prevValue].height/2};
                    this.setBackEnabled(false);
                    this.setButtonsEnabled(false);
                }
                this.signals.changePainting.dispatch(prevValue);
            }
        },
        setTweening: function(value) {
            if (this.tweening != value) {
                var prevValue = this.tweening;
                this.tweening = value;
                if (this.painting) {
                    if (prevValue === State.TWEEN_SCREEN || 
                        prevValue === State.TWEEN_PAINTING || 
                        (prevValue === State.TWEEN_ZOOM && !this.zoom) || 
                        (prevValue === State.TWEEN_INFO && !this.info)) {
                        this.setBackEnabled(true);
                        this.setButtonsEnabled(true);
                    }
                }
                else if (prevValue === State.TWEEN_SCREEN) {
                    this.startHighlight();
                }
                this.signals.changeTweening.dispatch(prevValue);
            }
        },
        setRotated: function(value) {
            if (this.rotated != value) {
                this.rotated = value;
                this.setBackEnabled(false);
                this.setButtonsEnabled(false);
                this.signals.changeRotated.dispatch(this.rotated);
            }
        },
        setUV: function(value) {
            if (this.uv != value) {
                this.uv = value;
                if (value) {
                    this.setBackEnabled(false);
                    this.setButtonsEnabled(false);
                }
                this.signals.changeUV.dispatch(this.uv);
            }
        },
        setZoom: function(value) {
            if (this.zoom != value) {
                this.zoom = value;
                if (value) {
                    this.setButtonsEnabled(false);
                }
                this.signals.changeZoom.dispatch(this.zoom);
            }
        },
        setZoomRect: function(painting, value) {
            if (this.zoomRect[painting] != value) {
                var prevValue = (this.zoomRect[painting] ? this.zoomRect[painting].clone() : this.zoomRect[painting]);
                this.zoomRect[painting] = value;
                if (!this.zoomPos[painting]) {
                    this.zoomPos[painting] = {x: value.width/2, y: value.height/2};
                }
                this.signals.changeZoomRect.dispatch(painting, prevValue);
            }
        },
        setZoomPos: function(painting, value) {
            if (this.zoomPos[painting] != value) {
                var prevValue = _.clone(this.zoomPos[painting]);
                this.zoomPos[painting] = value;
                this.signals.changeZoomPos.dispatch(painting, prevValue);
            }
        },
        setInfo: function(value) {
            if (this.info != value) {
                this.info = value;
                if (value) {
                    this.setBackEnabled(false);
                    this.setButtonsEnabled(false);
                }
                this.signals.changeInfo.dispatch(this.info);
            }
        },
        setBackEnabled: function(value) {
            if (this.backEnabled != value) {
                this.backEnabled = value;
                this.signals.changeBackEnabled.dispatch(this.backEnabled);
            }
        },
        setButtonsEnabled: function(value) {
            if (this.buttonsEnabled != value) {
                this.buttonsEnabled = value;
                this.signals.changeButtonsEnabled.dispatch(this.buttonsEnabled);
            }
        },
        setHighlight: function(value) {
            if (this.highlight != value) {
                var prevValue = this.highlight;
                this.highlight = value;
                this.signals.changeHighlight.dispatch(prevValue);
            }
        },
        startHighlight: function() {
            this._highlightId = setTimeout(_.bind(this.nextHighlight, this), State.HIGHLIGHT_TIMEOUT);
        },
        nextHighlight: function() {
            var nextHighlight = this.highlight+1 <= 3 ? this.highlight+1 : 1;
            this.setHighlight(nextHighlight);
            this.startHighlight();
        },
        stopHighlight: function() {
            clearTimeout(this._highlightId);
        },
        goBack: function() {
            if (this.painting) {
                if (this.zoom) {
                    this.setZoom(false);
                }
                else if (this.info) {
                    this.setInfo(false);
                }
                else {
                    this.setPainting(0);                    
                }
            }
        }
    };
    
    function StateSignals() {
        this.changePainting = new signals.Signal();
        this.changeTweening = new signals.Signal();
        this.changeRotated = new signals.Signal();
        this.changeUV = new signals.Signal();
        this.changeZoom = new signals.Signal();
        this.changeZoomRect = new signals.Signal();
        this.changeZoomPos = new signals.Signal();
        this.changeInfo = new signals.Signal();
        this.changeBackEnabled = new signals.Signal();
        this.changeButtonsEnabled = new signals.Signal();
        this.changeHighlight = new signals.Signal();
    }
    
    mms.State = State;
    mms.state = new State();
  
})(this);